import React from 'react';

interface Image360Props extends React.HTMLAttributes<HTMLDivElement> {
  image: string;
  className?: string;
}

const Image360: React.FC<Image360Props> = ({
  image,
  className = '',
  ...otherProps
}) => {
  return (
    <div className={`mz-image-360 ${className}`} data-src={image} {...otherProps}>
      <div className="mz-image-360-inner">
        <div className="mz-image-360-content">
          {/* panorama view is appended here by pannellum.js library from Core */}
        </div>
      </div>
    </div>
  );
};

export default Image360;
